import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

const ConfigNoSynthesis: React.FC = () => {
  const { setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();
  return (
    <>
      <Typography className="italic">
        Une synthèse est un court texte dans lequel vous pouvez injecter
        certaines valeurs des extractions une fois le traitement terminé.
      </Typography>
      <div className="flex justify-center">
        {!isReadOnly && (
          <Button
            variant="contained"
            onClick={() => setValue("config.synthesis", "")}
            className="gap-2"
          >
            <Add />
            Synthèse
          </Button>
        )}
      </div>
    </>
  );
};
export default ConfigNoSynthesis;
